import * as UI from "@accurx/design";
import styled from "styled-components";

export const StyledWrapper = styled.div`
    background-color: var(--ds-color-white);
    border-bottom: 1px solid var(--ds-color-silver);
    width: 100%;
    padding: 1rem 0;
`;

export const Inner = styled.div`
    max-width: ${UI.Tokens.BREAKPOINTS.md};
    margin: 0 auto;
`;
